import { dispatch } from "config/store";
import { actionTypes } from "./actionTypes";

export const changeRoute = (route) => {
    const action = {
        type: actionTypes.CHANGE_ROUTE,
        payload: route,
    };
    dispatch(action);
};